import Session from "../auth/Session";

const CalsCertsFunctions = {
    getCalibrationsAsync: async function () {
        const token = Session.getToken();
        const response = await fetch(`api/calibration/getcalibrations`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    },
    getCalibrationHistoryAsync: async function (ticNo, ccpNo) {
        const token = Session.getToken();
        const response = await fetch(`api/calibration/getcalibrationhistory`, {
            method: "POST",
            body: JSON.stringify({ "TICNo" : ticNo, "PartNo" : ccpNo }),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        return data;
    },
    getCurrentCertAsync: async function (ccpNo) {
        const token = Session.getToken();
        const response = await fetch(`api/CalsAndCerts/GetCertificates`, {
            method: "POST",
            body: JSON.stringify({ "ccpNo": ccpNo }),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type':  'application/json' }
        });
        const data = await response.json();
        return data;
    },
    getAccountById: async function (id) {
        const token = Session.getToken();
        const response = await fetch(`api/Account/GetAccountByIdAsync`, {
            method: "POST",
            body: JSON.stringify({ "id" : id }),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    },
    getFileAuth: async function () {
        const token = Session.getToken();
        const response = await fetch(`api/calibration/getfileauth`, {
            method: "GET",
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    },
    getCertificateFileAsync: async function (formData) {
        const token = Session.getToken();
        const response = await fetch('api/calibration/getcertificatefileasync', {
            method: "POST",
            body: JSON.stringify(formData),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const data = response;
        return data;
    },
    getPastCertificateFileAsync: async function (ticNo, fileName) {
        const token = Session.getToken();
        const response = await fetch('api/calibration/getpastcertificatefileasync?ticNo=' + ticNo + '&fileName=' + fileName, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const data = response;
        return data;
    },
    getCertificateZipFileAsync: async function (formData) {
        const token = Session.getToken();
        const response = await fetch('api/calibration/getcertificatezipfileasync', {
            method: "POST",
            body: JSON.stringify(formData),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const data = response;
        return data;
    }
}

export default CalsCertsFunctions;